import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-order_down",
  "use": "icon-order_down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-order_down\">\n  <path d=\"M820.1472 896a52.0704 52.0704 0 0 0 37.0688-15.2576l125.696-125.184c20.5312-20.48 20.6592-53.76 0.3072-74.3936a52.1984 52.1984 0 0 0-74.0352-0.3072L870.4 719.4624V179.2a51.2 51.2 0 0 0-47.36-51.072L819.2 128a51.2 51.2 0 0 0-51.2 51.2v665.6a51.2 51.2 0 0 0 51.712 51.2zM640 268.8a51.2 51.2 0 1 0 0-102.4H76.8a51.2 51.2 0 1 0 0 102.4z m0 307.2a51.2 51.2 0 1 0 0-102.4H76.8a51.2 51.2 0 1 0 0 102.4z m0 307.2a51.2 51.2 0 1 0 0-102.4H76.8a51.2 51.2 0 1 0 0 102.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/order_down.svg
// module id = wT/f
// module chunks = 58